import { useState, KeyboardEvent, useContext } from 'react'

import { RouteDetails } from '@/types/routeDetails'
import { Input } from '@/ui/Input'
import { useSendRouteStrategy } from '../../api/useSendRouteStrategy'
import { formatStrategyTime } from '../../helpers/formatStrategyTime'
import { RouteDetailsContext } from '../context'

import styles from './Strategy.module.scss'

import ArrowRightIcon from '../../assets/arrow-right.svg'

export const Strategy = ({ strategies, route }: Pick<RouteDetails, 'strategies' | 'route'>) => {
    const [strategy, setStrategy] = useState('')
    const { handleSendRouteStrategy } = useSendRouteStrategy(route)
    const { readOnly } = useContext(RouteDetailsContext)

    const handleSend = () => {
        if (!strategy) {
            return
        }

        handleSendRouteStrategy(strategy)
        setStrategy('')
    }

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            handleSend()
        }
    }

    if (readOnly && !strategies.length) {
        return null
    }

    return (
        <div className={styles.root}>
            <h4 className={styles.head}>Strategy</h4>
            {!readOnly && (
                <div className={styles.inputWrapper}>
                    <Input
                        onKeyDown={handleKeyDown}
                        value={strategy}
                        className={styles.input}
                        fullWidth
                        placeholder="Update strategy"
                        hidePlaceholderOnFocus
                        customAction={
                            <button className={styles.action} type="button" onClick={handleSend}>
                                <ArrowRightIcon />
                            </button>
                        }
                        onChange={(event) => setStrategy(event.target.value)}
                    />
                </div>
            )}
            <div className={styles.list}>
                {strategies.map((item) => (
                    <div key={item.id} className={styles.item}>
                        <p className={styles.itemTitle}>{item.strategy}</p>
                        <div className={styles.itemDescription}>
                            <span>{item.userShift.authorName}</span>
                            <span className={styles.itemHint}>{formatStrategyTime(item.timestamp)}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
